"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialButton = void 0;
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var react_1 = tslib_1.__importStar(require("react"));
var SvgImage_1 = require("../../../../../components/SvgImage");
var social_service_1 = require("../../../services/social.service");
var socialNetworkImageDict = (_a = {},
    _a[social_service_1.SocialNetworks.FACEBOOK] = 'sprites.svg#network-facebook',
    _a[social_service_1.SocialNetworks.TWITTER] = 'sprites.svg#network-twitter',
    _a[social_service_1.SocialNetworks.LINKEDIN] = 'sprites.svg#network-linkedin',
    _a[social_service_1.SocialNetworks.EMAIL] = 'sprites.svg#network-email',
    _a);
exports.SocialButton = mobx_react_1.inject('globalStore')(function (props) {
    var buttonClick = react_1.useCallback(function () {
        if (!props.globalStore) {
            return;
        }
        props.globalStore.socialService.showSocialWindow(props.network, props.shareText);
        // tslint:disable-next-line:no-unused-expression
        props.onSocialShare && props.onSocialShare(props.network);
    }, []);
    return (react_1.default.createElement("button", { onClick: buttonClick, className: "c-social-share__item c-social-share__item--" + props.network },
        react_1.default.createElement(SvgImage_1.SvgImage, { className: 'social-share-icon', image: socialNetworkImageDict[props.network], height: props.height, width: props.width })));
});
